export default {
  service: {
    title: 'My Services',
    subtitle: 'You can access all your platforms',
    otherAvailable: 'All available services',
    access: 'Access this service',
    enable: 'Enable this service',
    moreService: 'See all my services',
    dialogContent: {
      content: 'To access this service, you must contact the support team at 01 23 45 67 89 or by email at Loremipsum{\'@\'}dolor.sit',
      subtitle: 'Access a new service'
    },
    legalMentions: 'Legal Mentions',
    eula: 'EULA',
    endUserLicenseAgreement: 'End-User License Agreement',
    applicationSettings: 'Application settings'
  },
  support: {
    title: 'Support',
    contact: 'Contact',
    phone: 'Phone number',
    mail: 'Email address',
    links: 'Useful links',
    webSite: 'Our website',
    headOffice: 'Head office'
  }
}
